import { Loading } from "element-ui";

/** 下载文件 */
export function downloadFile(res, name) {
  let headers = res.headers;
  console.log(headers);
  // let filename = (headers["content-disposition"] || "")
  //   .split(";")[2]
  //   .split("filename*=UTF-8")[1];
  // filename = filename.replace("''", "");
  // filename = decodeURI(filename);
  let blob = new Blob([res.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  let link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = name + " - 下载记录.xlsx";
  link.click();
}
// import { Loading } from "element-ui";

// /** 下载文件 */
// export function downloadFile(res) {
//   var xhr = new XMLHttpRequest();
//   xhr.open(
//     "GET",
//     "File(result， &quot;application/vnd.openxmlformats-officedocument.spreadsheetml.sheet&quot;, fileName)",
//     true
//   );
//   xhr.responseType = "blob";
//   xhr.onload = function () {
//     if (this.status == 200) {
//       var blob = new Blob([res.data], {
//         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//       });
//       var link = document.createElement("a");
//       link.href = window.URL.createObjectURL(blob);
//       link.download = "下载记录.xlsx";
//       link.click();
//     }
//   };
//   xhr.send();
// }
